import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import PropTypes from "prop-types";
import { Link, useParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { bookingApi, masterApi } from "functions/apis";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

export function ViewPort(props) {
  const classes = useStyles();

  const viewPortSignal = React.useRef(new AbortController());

  const { id } = useParams();

  const [data, setData] = useState(null);
  const [portBooking, setPortBooking] = useState(null);

  useEffect(() => {
    return () => viewPortSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      masterApi
        .get(`Ports/${id}`, {
          signal: viewPortSignal.current.signal
        })
        .then(resp => {
          setData(resp);
        });
    }
  }, [id]);

  useEffect(() => {
    if (
      data !== null &&
      data.publicationStatus !== 0 &&
      (token["booking.ports.read"] === "allowed" || token.is_admin === "True")
    ) {
      bookingApi
        .get("/Ports/" + id, {
          signal: viewPortSignal.current.signal
        })
        .then(resp => setPortBooking(resp))
        .catch(error => console.log(error));
    }
  }, [data]);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>VIEW PORT</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <GridContainer>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.code : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.name : "",
                    disabled: true
                  }}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        {data !== null && data.publicationStatus !== 0 && portBooking !== null && (
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>BOOKING CONFIGURATION</h4>
            </CardHeader>
            <CardBody>
              {(token["booking.ports.write"] === "allowed" ||
                token.is_admin === "True") &&
                data.publicationStatus === 1 && (
                  <Link to={"/admin/Port/EditBookingConfiguration/" + id}>
                    <Button color="rose" type="button" value="Edit">
                      Edit
                    </Button>
                  </Link>
                )}
              <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText="Schedule Time Zone"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: portBooking.scheduleTimeZone ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText="SCC Code"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: portBooking.sccCode ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText="BTC Code"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value: portBooking.btcCode ?? ""
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        )}
      </GridItem>
    </GridContainer>
  );
}

ViewPort.propTypes = {
  history: PropTypes.object
};
